import type { CourseTier } from "../types/api";

export function planName(plan: CourseTier | null) {
  if (plan === "B") return "Programmer B";
  if (plan === "A") return "Programmer A";
  return "No plan";
}

export function initials(value: string) {
  return value
    .split(/\s+|@/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

export function clamp(value: number, min = 0, max = 100) {
  return Math.min(max, Math.max(min, value));
}
